module.exports = __webpack_public_path__ + "static/media/1003130.13f5ce9b.png";